import { User, UserManager } from 'oidc-client-ts';
import { config } from './config';

const userManager = new UserManager({
  authority: config.oidc.authority,
  client_id: config.oidc.clientId,
  redirect_uri: config.oidc.redirectUri,
  post_logout_redirect_uri: config.oidc.postLogoutRedirectUri,
  response_type: 'code',
  scope: config.oidc.scope,
  automaticSilentRenew: false,
  ...(config.oidc.audience ? { extraQueryParams: { audience: config.oidc.audience } } : {}),
});

export async function signIn(): Promise<void> {
  await userManager.signinRedirect();
}

export async function signOut(): Promise<void> {
  await userManager.removeUser();
  window.location.href = '/';
}

export async function handleSignInCallback(): Promise<User> {
  return userManager.signinRedirectCallback();
}

export async function getUser(): Promise<User | null> {
  return userManager.getUser();
}

export async function getAccessToken(): Promise<string | null> {
  const user = await getUser();
  return user?.access_token ?? null;
}

export async function clearStaleState(): Promise<void> {
  await userManager.clearStaleState();
}
